import { i18n } from '@/services/i18n';
import { LoadEventType } from '@/interfaces/server-data';

function buildRussianLabelToType(): Record<string, LoadEventType> {
    const messages = i18n.messages as any;
    const ruTypes = (messages && messages.ru && messages.ru.events && messages.ru.events.types
        ? messages.ru.events.types
        : {}) as Record<string, string>;
    const map: Record<string, LoadEventType> = {};
    Object.keys(ruTypes).forEach((type) => {
        const label = String(ruTypes[type]).trim();
        if (label) {
            map[label] = type as LoadEventType;
        }
    });
    return map;
}

export function localizeEventTriggerTypes(raw: string): string {
    const reverse = buildRussianLabelToType();
    return raw
        .split(',')
        .map((part) => part.trim())
        .filter(Boolean)
        .map((part) => {
            const type = reverse[part];
            return type ? (i18n.t(`events.types.${type}`) as string) : part;
        })
        .join(', ');
}

export function formatEventTriggerDisplay(
    row: { eventTrigger?: boolean; eventTriggerTypes?: string | null },
): string {
    if (row.eventTriggerTypes) {
        return localizeEventTriggerTypes(row.eventTriggerTypes);
    }

    return row.eventTrigger ? (i18n.t('shared.boolFilter.yes') as string) : '';
}

export function toSortOrder(sorterOrder: string): string {
    if (sorterOrder == 'ascend') {
        return 'ASC'
    } else if (sorterOrder == 'descend') {
        return 'DESC'
    } else {
        return sorterOrder
    }
}

export function downloadBlobAsFile(blob: Blob, fileName: string): void {
    const url = window.URL.createObjectURL(new Blob([blob]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
}

export function normalizeNumericInput(value: any): string {
    if (value === undefined || value === null) {
        return '';
    }

    return value.toString()
        .replace(/[\s ]/g, '')
        .replace(/,/g, '.')
        .replace(/%$/, '');
}

export function numberGteZeroState(value: any, required: boolean = false): boolean | null {
    const normalized = normalizeNumericInput(value);

    if (normalized === '') {
        return required ? false : null;
    }

    const numberValue: number = Number(normalized);

    return isFinite(numberValue) && numberValue >= 0;
}

export function numberGteZeroFeedbackKey(value: any, required: boolean = false): string {
    if (required && normalizeNumericInput(value) === '') {
        return 'regular.validation.fieldNotEmpty';
    }

    return 'regular.validation.numberGteZero';
}

export function isValidNumberValue(value: any, allowZero: boolean = true): boolean {
    if (value === undefined || value === null || value === '' || !['number', 'string'].includes(typeof value)) {
        return false;
    } else {
        if (!allowZero) {
            const numberValue: number = Number(value);

            return !isNaN(numberValue) && numberValue !== 0;
        } else {
            return !isNaN(Number(value));
        }
    }
}
